"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawDataMapperBodyToJSON = exports.RawDataMapperBodyFromJSONTyped = exports.RawDataMapperBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function RawDataMapperBodyFromJSON(json) {
    return RawDataMapperBodyFromJSONTyped(json, false);
}
exports.RawDataMapperBodyFromJSON = RawDataMapperBodyFromJSON;
function RawDataMapperBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'source': (0, _1.DataSourceFromJSON)(json['source']),
        'eventTypeId': json['eventTypeId'],
        'mappings': json['mappings'],
        'gameId': json['gameId'],
        'jsonValidator': json['jsonValidator'],
        'exampleDataString': !(0, runtime_1.exists)(json, 'exampleDataString') ? undefined : json['exampleDataString'],
        'incrementCounterField': !(0, runtime_1.exists)(json, 'incrementCounterField') ? undefined : json['incrementCounterField'],
        'isActive': !(0, runtime_1.exists)(json, 'isActive') ? undefined : json['isActive'],
    };
}
exports.RawDataMapperBodyFromJSONTyped = RawDataMapperBodyFromJSONTyped;
function RawDataMapperBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'source': (0, _1.DataSourceToJSON)(value.source),
        'eventTypeId': value.eventTypeId,
        'mappings': value.mappings,
        'gameId': value.gameId,
        'jsonValidator': value.jsonValidator,
        'exampleDataString': value.exampleDataString,
        'incrementCounterField': value.incrementCounterField,
        'isActive': value.isActive,
    };
}
exports.RawDataMapperBodyToJSON = RawDataMapperBodyToJSON;
